module.exports = __webpack_public_path__ + "assets/img/noInfo.36c9c913.png";